import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { HumanResourcesComponent } from '../../views/human-resources/human-resources.component';
import {MatProgressSpinnerModule, MatGridListModule} from '@angular/material';
import { HumanResourcesService } from '../../views/human-resources/human-resources.service';
import {MatTabsModule} from '@angular/material/tabs';
import {MatInputModule} from '@angular/material/input';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from "../../views/authentication/authentication.service";
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatProgressBar} from '@angular/material/progress-bar'
import { Subscription, Observable } from '../../../../node_modules/rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './app-progress-bar.component.html',
  styleUrls: ['./app-progress-bar.component.scss'],
})
export class AppProgressBar implements OnInit {
  @Input() time = 10;
  constructor(private router: Router)
  { }
  private http: HttpClient;
  private auth: AuthenticationService;
  public message:any = ", loading...";
  public count: any = 0;
  public num :any = 0;
  public numtotal:any;
  public sub:Subscription;
  public contador: any;
  public secs:any;
  public mins:any;


  public funnyMessages:any = [
    ", the architects are still drafting",
    ", the bits are breeding",
    ", we're building the buildings as fast as we can",
    ", pay no attention to the man behind the curtain",
    ", and enjoy the elevator music",
    ", while the little elves draw your site",
    ", a few bits tried to escape, but we caught them",
    ", and dream of faster computers",
    ", at least you're not on hold",
    ", the server is powered by a lemon and two electrodes",
    ", we love you just the way you are",
    ", we're testing your patience",
    ", as if you had any other choice",
    ", take a moment to sign up for our lovely prizes",
    ", why don't you order a sandwich?",
    ", while the satellite moves into position",
    ", the bits are flowing slowly today",
    ", loading funny message...",
    ", measuring the cable length to fetch your data...",
    ", searching for answer to Life, the Universe, and Everything",
    ", give us 2 seconds",
    ", while we try to understand the meaning of AT field",
    ", system admin has to hit enter...",
    ", warming up the processors...",
    ", reconfiguring the office coffee machine...",
    ", working... So, how are you?",
    ", and count to 10...",
    ", working... well... you know...",
    ", but why so serious?",
    ", attentively (which is what you agreed to in the Terms and Conditions)",
    ", counting backwards from infinity",
    ", CTRL-C ... CTRL-V",
    ", generating next funny line...",
    ", loading new loading screen.",
    ", loading screen... If you can see this then it's already loaded",
    ". Stay determined!"
  ]

  ngOnInit() { 
    
    if (this.router.url == "/total-graph" || this.router.url == "/hr" || this.router.url == "/personal-spent"){
      this.mins = Math.floor((Math.random() * 5) + 3); 
      this.contador = this.mins + " minutes"
      this.sub = Observable.interval(60000)
      .subscribe((val) => { 
        if (this.mins > 0){
          this.mins = this.mins - 1 ;
          if (this.mins == 0){
            this.contador = this.mins + " minute"; 
          }else{
            this.contador = this.mins + " minutes"; 
          }
        }else{
          this.contador = ""; 
        }
      });
      
    }else{
      this.secs = Math.floor((Math.random() * 20) + 10); 
      //console.log("random second: "+ this.secs);
      this.contador = this.secs + " seconds"
      this.sub = Observable.interval(1000)
      .subscribe((val) => { 
        if (this.secs > 0){
          this.secs = this.secs - 1 ;
        this.contador = this.secs + " seconds"; 
        }
        else{
          this.contador = ""; 
        }
      });

    }
    
    
    //this.message = ", loading funny message...";
    this.numtotal = Math.floor((Math.random() * 10) + 10); 
    this.numtotal = this.numtotal * 1000;   
    //console.log(this.numtotal);
    this.sub = Observable.interval(this.numtotal).subscribe((something) => {
      this.cambiarMensaje();
      //console.log(this.num);
    });
    
  }

  cambiarMensaje()
  {
    this.num = Math.floor((Math.random() * 36) + 1);
    this.message = this.funnyMessages[this.num];
    //console.log(this.num);
  }

  ngOnDestroy()
  {
    if (this.sub)
    {
      this.sub.unsubscribe();
    }
  }

}






// WEBPACK FOOTER //
// ./src/app/components/app-progress-bar/app-progress-bar.component.ts